if (!customElements.get('product-recommendations')) {
    customElements.define(
        'product-recommendations',
        class ProductRecommendations extends HTMLElement {
            constructor() {
                super();
            }

            connectedCallback() {
                const handleIntersection = (entries, observer) => {
                    if (!entries[0].isIntersecting) return;
                    observer.unobserve(this);
                    fetch(this.dataset.url)
                        .then(response => response.text())
                        .then(text => {
                            const html = document.createElement('div');
                            html.innerHTML = text;
                            const recommendations = html.querySelector('product-recommendations');
                            if (recommendations && recommendations.innerHTML.trim().length) {
                                this.innerHTML = recommendations.innerHTML;

                                const countFromResponse = html.querySelector('product-recommendations').dataset.productCount;

                                const productCards = this.querySelectorAll('[data-complementary-product="true"]');
                                const productCount = productCards.length;

                                // Update the slider element with the correct count if it exists
                                const slider = this.querySelector('complementary-product-slider');
                                if (slider && productCount > 0) {
                                    slider.dataset.slideCount = productCount;
                                }
                                // Dispatch event when products are found
                                if (this.querySelector('.product-card')) {
                                    this.dispatchEvent(new CustomEvent('recommendations:loaded', {
                                        bubbles: true,
                                        detail: {
                                            productCount: productCount
                                        }
                                    }));
                                }
                            } else {
                                this.dispatchEvent(new CustomEvent('recommendations:not-found', {bubbles: true}));
                                this.remove();
                            }
                        })
                        .catch(e => {
                            console.error(e);
                            this.dispatchEvent(new CustomEvent('recommendations:not-found', {bubbles: true}));
                            this.remove();
                        });
                };

                new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
            }
        }
    );
}
